import './src/vaadin-item.js';
export * from './src/vaadin-item.js';
